<template>
  <div class="quote-page">
    <!-- Tre preventivi nella stessa pagina, impaginati allo stesso modo:
         Pickup & Delivery e pacchetto valet per chi ha le prenotazioni,
         spostamento interno per chi ha gli spostamenti. -->
    <header class="quote-head">
      <h1 class="quote-title">
        Preventivo
      </h1>
    </header>
    <el-tabs
      v-model="scheda"
      class="quote-tabs"
    >
      <el-tab-pane
        v-if="store.bookingType"
        label="Pickup & Delivery"
        name="pickup"
      >
        <PreventivoPickup />
      </el-tab-pane>
      <el-tab-pane
        v-if="store.journeyType"
        label="Spostamento interno"
        name="journey"
      >
        <PreventivoSpostamentoInterno />
      </el-tab-pane>
      <el-tab-pane
        v-if="store.bookingType"
        label="Pacchetto valet"
        name="valet"
      >
        <PreventivoVenditaValet />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { ref } from 'vue';
import PreventivoPickup from '../Components/PreventivoPickup.vue';
import PreventivoSpostamentoInterno from '../Components/PreventivoSpostamentoInterno.vue';
import PreventivoVenditaValet from '../Components/PreventivoVenditaValet.vue';
import { isLoggedStore } from '../store/logged';

export default {
  name: 'EstimatePage',
  components: {
    PreventivoPickup,
    PreventivoSpostamentoInterno,
    PreventivoVenditaValet,
  },

  setup() {
    const store = isLoggedStore();
    // Si apre sulla prima scheda che il partner può usare.
    const scheda = ref(store.bookingType ? 'pickup' : 'journey');
    return { store, scheda };
  },
};
</script>

<style scoped>
.quote-page { padding: 4px 8px 48px; text-align: left; }
.quote-head { margin-bottom: 8px; }
.quote-title { margin: 0; font-size: 23px; font-weight: 700; letter-spacing: -0.015em; }
</style>
